module.exports = __webpack_public_path__ + "static/media/reshma_she.c81da6dc.jpeg";